import React from "react";
import * as Icon from "react-feather";

import "./quickbooks-drift-modal.css";
import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import QuickBooksMovedAccounts from "./QuickBooksMovedAccounts";

class QuickBooksDriftModal extends WComponent {
	state = { reason: "", signing: false };

	onReasonChange = event => this.update({ reason: event.target.value });

	onSign = async () => {
		await this.update({ signing: true });
		await this.props.onSignWithReason({ sourceDriftReason: this.state.reason.trim() });
		await this.update({ signing: false });
	};

	renderFooter = () => {
		const { onClose } = this.props;
		const { reason, signing } = this.state;
		const hasAReason = reason.trim().length > 0;
		return (
			<span className="tk-modal-actions">
				<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Cancel</button>
				<button
					type="button"
					className="tk-button tk-button--primary"
					disabled={!hasAReason || signing}
					title={hasAReason ? undefined : "Say why the figures as pulled are still right"}
					onClick={this.onSign}
				>
					{signing ? "Signing off…" : "Sign off with this reason"}
				</button>
			</span>
		);
	};

	render() {
		const { drift, onClose } = this.props;
		if (!drift) return null;

		return (
			<ToolsModal open onClose={onClose} title="QuickBooks has changed since the pull" width={680} footer={this.renderFooter()}>
				<div className="qbdrift">
					{drift.reachable ? (
						<p className="tk-lead">
							These balances in QuickBooks are different from the ones these statements were built on. Refresh from QuickBooks on the
							statements brings them up to date. To sign off on the figures as pulled, say why they are still right.
						</p>
					) : (
						<div className="tk-notice tk-notice--warning">
							<div className="tk-notice__head">
								<span className="tk-notice__title">
									<Icon.WifiOff size={14} />
									QuickBooks could not be checked
								</span>
							</div>
							<p className="tk-notice__detail">{drift.unreachableBecause}</p>
						</div>
					)}

					<QuickBooksMovedAccounts moved={drift.moved} />

					<label className="tk-form-field">
						<span className="tk-form-label">Reason for signing off <span className="tk-form-required">*</span></span>
						<textarea className="tk-input qbdrift__reason" rows={3} value={this.state.reason} onChange={this.onReasonChange} />
						<span className="tk-form-help">Recorded with the sign-off, together with the changes listed above.</span>
					</label>
				</div>
			</ToolsModal>
		);
	}
}

export default QuickBooksDriftModal;
